import React from 'react';

/**
 * Lightweight replacement for Inventory's SquircleBox.
 * Keeps the same API so SidebarItem styling matches.
 */
export function SquircleBox({
  children,
  className,
  'aria-label': ariaLabel,
  allowOverflow = false,
}) {
  return (
    <div
      className={className}
      style={{ overflow: allowOverflow ? 'visible' : 'hidden' }}
      {...(ariaLabel ? { 'aria-label': ariaLabel } : {})}
    >
      {children}
    </div>
  );
}

